import { Tooltip } from 'react-tooltip';
import { FundingPartnerMatch } from '../types';

export const FundingPartnerMatchIcon = (props: {
  uniqueId: string;
  match: FundingPartnerMatch;
}) => {
  const { uniqueId, match } = props;
  return (
    <>
      <span data-tooltip-id={uniqueId} data-tooltip-place={'bottom'}>
        {match.isMatch === false ? '🔴' : match.isMatch === true ? '🟢' : '⚪'}
      </span>
      <Tooltip
        id={uniqueId}
        className="info-button__tooltip"
        noArrow={true}
        place={'bottom'}
        positionStrategy={'absolute'}
      >
        <span>{match.message}</span>
      </Tooltip>
    </>
  );
};
